import * as styledComponents from 'styled-components';
import { theme, TinkFontSizes } from '@tink/core/src/components/providers/ThemeProvider/theme';
import { TinkLinkTheme } from '../../components/ApplicationProviders/ConfiguredThemeProvider/tinkLinkTheme';

const { default: styled, css } =
  styledComponents as unknown as styledComponents.ThemedStyledComponentsModule<TinkLinkTheme>;

export { styled, css };

export enum ResponsiveSizeTypes {
  MB = 'margin-bottom',
  MT = 'margin-top',
  PB = 'padding-bottom',
  PT = 'padding-top',
  W = 'width',
  H = 'height',
}

export enum Heights {
  S = 0,
  M = 400,
  L = 500,
}

type SizesKeys = keyof typeof theme.sizes;

type SizesRem = typeof theme.sizes[SizesKeys];

type ResponsiveSizeProps = { type: ResponsiveSizeTypes; size: SizesRem };

export const typeToCss = ({ type, size }: ResponsiveSizeProps) => `${type}: ${size};`;

type SizeMap = { size: SizesRem; breakpoint: Heights };

export const cssWithBreakPoints = (
  type: ResponsiveSizeTypes,
  defaultSize: SizesRem,
  sizeMaps: SizeMap[]
) => {
  return `
  ${typeToCss({ type, size: defaultSize })}

  ${sizeMaps
    .map((sizeMap) => {
      const getBreakpoints = (from: Heights, to: Heights) =>
        `(min-height: ${from}px) and (max-height: ${to}px)`;

      if (sizeMap.breakpoint === Heights.S) {
        return `
          @media ${getBreakpoints(Heights.S, Heights.M)}{
            ${typeToCss({ type, size: sizeMap.size })}
          }`;
      }

      if (sizeMap.breakpoint === Heights.M) {
        return `
          @media ${getBreakpoints(Heights.M, Heights.L)}{
            ${typeToCss({ type, size: sizeMap.size })}
          }`;
      }

      return '';
    })
    .join(';')}`;
};

export const responsiveSize = ({ type, size }: ResponsiveSizeProps) => {
  switch (size) {
    case theme.sizes.large:
      return cssWithBreakPoints(type, size, [
        { size: theme.sizes.none, breakpoint: Heights.S },
        { size: theme.sizes.small, breakpoint: Heights.M },
      ]);
    default:
      return typeToCss({ type, size });
  }
};

export type TinkLinkFontSizes = TinkFontSizes | 'inherit';
